// SEO.jsx
import { Helmet } from "react-helmet-async";
import seoConfig from "../SeoConfig";

export default function SEO({ page }) {
  const config = seoConfig[page] || {};
  const { title, description, primaryKeywords = [], secondaryKeywords = [], canonical } = config;

  // merge keywords for meta tag
  const allKeywords = [...primaryKeywords, ...secondaryKeywords].join(", ");

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {allKeywords && <meta name="keywords" content={allKeywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
}
